class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.menuSummaries = this.querySelectorAll('summary.header__menu-item');
    this.menuSummaries.forEach(summary => {
      summary.addEventListener('click', () => {
        const details = summary.parentElement;
        if (details.hasAttribute('open') && document.documentElement.scrollTop === 0) {
          this.header.classList.remove('--bgcolor');
        }
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    const event = new CustomEvent('menuToggle', { detail: { isOpen: this.mainDetailsToggle.open } });
    window.dispatchEvent(event);
    const scrollTop = document.documentElement.scrollTop;

    if (this.mainDetailsToggle.open && scrollTop === 0) {
      document.querySelector('.header-wrapper').classList.add('--bgcolor');
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

document.addEventListener('click', function (event) {
  if (window.innerWidth <= 989) return;
  const header = document.querySelector('.header-wrapper');
  const menus = document.querySelectorAll('.mega-menu');
  const clickInsideMenu = Array.from(menus).some(menu => menu.contains(event.target));

  if (!clickInsideMenu && document.documentElement.scrollTop === 0) {
    header.classList.remove('--bgcolor');
  }
});